import { regexPatterns } from '../../../utilities/validation/validationVariables';
import UpdateMailingFailed from './updateMailingFailed.js';
import ServiceButtons from '../../Shared/ServiceButtons/ServiceButtons';
import { gaInvoiceSuccessPage,gaInvoiceErrorMessageGeneral,gaErrorMessagePhoneNumBlockedForMailing,gaInvoiceSuccessPageInvoiceNotSent } from './gaReports';

export const MessageFormat = {
  Page: 'Page',
  PopUp: 'PopUp',
};

export const MailingMethod = {
  Mail: 'דוא"ל',
  Phone: 'SMS',
};

export const NumberValidationStatus = {
  BLOCK: 'BLOCK',
  OPEN: 'OPEN',
};

export const stepEnum = {
  SELECT_BAN: 'selectBan',
  UPDATE_MAILING_METHOD: 'updateMailingMethod',
  UPDATE_STATUS_MESSAGE: 'updateStatusMessage',
};

const supportNumber = () => window.Config?.technicalSupportPhone;
export const MessageContent = {
  updateSucceeded: {
    title: 'שינוי כתובת לקבלת חשבונית ירוקה<br/> בוצע בהצלחה!',
    subTitle: '',
    icon: require('./icons/like.svg'),
    buttonText: 'סיום',
    format: MessageFormat.Page,
    reporterMessage: 'Update success',
    status :'Completed',
    gaFunction:'gaInvoiceSuccessPage'
  },
  partialUpdateSucceeded: {
    title: 'מצטערים, משהו השתבש<br/> וחלק מהכתובות לא עודכנו',
    subTitle: `ניתן ליצור קשר עם נציג שירות ב ${supportNumber()}`,
    icon: require('./icons/error.svg'),
    buttonText: 'סיום',
    format: MessageFormat.Page,
    description: 'UpdateMailingFailed',
    failedBans: [],
    reporterMessage: 'Update success',
    status :'Completed',
    gaFunction:'gaInvoiceSuccessPageInvoiceNotSent'
  },
  numberValidationFailed: {
    title: 'שימו לב<br/> זיהינו שאי אפשר לשלוח<br/>  למספר זה הודעות דיוור',
    subTitle: 'לא נורא, אפשר לעדכן למספר אחר',
    icon: require('./icons/hey.svg'),
    buttonText: 'הבנתי, תודה',
    format: MessageFormat.PopUp,
    reporterMessage: 'not Allowed To Update',
    status :'Error',
    gaFunction : 'gaErrorMessagePhoneNumBlockedForMailing'
  },
  generalError: {
    title: 'מצטערים, כרגע לא ניתן  <br/>לבצע את הפעולה שביקשת',
    subTitle: '',
    description :'ServiceButtons',
    icon: require('./icons/error.svg'),
    format: MessageFormat.Page,
    reporterMessage: 'General Error',
    status :'Error',
    gaFunction :'gaInvoiceErrorMessageGeneral'
  },
  notAllowedToUpdate:{
    title: 'על מנת לשנות את אופן הדיוור של החשבונית הירוקה <br/>יש לפנות למוקד השירות',
    subTitle: '',
    description :'ServiceButtons',
    icon: require('./icons/error.svg'),
    format: MessageFormat.Page,
    reporterMessage: 'Ban cannot be updated',
    status :'Error',
    gaFunction :'gaInvoiceErrorMessageGeneral'
  }
};

export const InputValidation = {
  Mail: {
    regexPattern: regexPatterns.emailRegex,
    error: {
      emptyInput: 'יש להזין כתובת מייל',
      invalidInput: 'יש להזין כתובת מייל תקנית',
    },
  },
  Phone: {
    regexPattern: regexPatterns.phoneRegex,
    error: {
    emptyInput: 'יש להזין מספר טלפון',
    invalidInput: 'יש להזין מספר טלפון תקין',
    },
  },
};
export const DynamicComponent = {
  UpdateMailingFailed,
  ServiceButtons
};

export const gaMailingFunctionMap = {
  gaInvoiceSuccessPage,
  gaInvoiceErrorMessageGeneral,
  gaErrorMessagePhoneNumBlockedForMailing,
  gaInvoiceSuccessPageInvoiceNotSent
};

export const getMailingAdress = (ban) => {
  switch (ban.bill_method.trim()) {
    case 'A':
      return ban.email_bill_dest;
    case 'RP':
      return ban.billingAddress.streetName + ' ' + ban.billingAddress.houseNum + ',' + ban.billingAddress.city;
    case 'SM':
      return ban.sms_bill_dest;
    default:
      break;
  }
};
